import React from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./hero.css";
import herobg from "./hero_bg.jpg";
import Typewriter from "typewriter-effect";
// import Particles from "react-tsparticles";
const Hero = () => {
  // const particlesInit = (main) => {
  //   console.log(main);
  // };
  // const particlesLoaded = (container) => {
  //   console.log(container);
  // };

  AOS.init({
    // Global settings:
    disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
    startEvent: "DOMContentLoaded", // name of the event dispatched on the document, that AOS should initialize on
    initClassName: "aos-init", // class applied after initialization
    animatedClassName: "aos-animate", // class applied on animation
    useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
    disableMutationObserver: false, // disables automatic mutations' detections (advanced)
    debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
    throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)

    // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
    offset: 120, // offset (in px) from the original trigger point
    delay: 0, // values from 0 to 3000, with step 50ms
    duration: 1000, // values from 0 to 3000, with step 50ms
    easing: "ease", // default easing for AOS animations
    once: false, // whether animation should happen only once - while scrolling down
    mirror: false, // whether elements should animate out while scrolling past them
    anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
  });

  return (
    <div id="hero">
      {/* <Particles
      id="tsparticles"
      init={particlesInit}
      loaded={particlesLoaded}
      options={{
        fpsLimit: 60,
        interactivity: {
          events: {
            onClick: {
              enable: true,
              mode: "push",
            },
            onHover: {
              enable: true,
              mode: "repulse",
            },
            resize: true,
          },
          modes: {
            bubble: {
              distance: 400,
              duration: 2,
              opacity: 0.8,
              size: 40,
            },
            push: {
              quantity: 4,
            },
            repulse: {
              distance: 200,
              duration: 0.4,
            },
          },
        },
        particles: {
          color: {
            value: "#ffffff",
          },
          links: {
            color: "#ffffff",
            distance: 150,
            enable: true,
            opacity: 0.5,
            width: 1,
          },
          collisions: {
            enable: true,
          },
          move: {
            direction: "none",
            enable: true,
            outMode: "bounce",
            random: false,
            speed: 6,
            straight: false,
          },
          number: {
            density: {
              enable: true,
              value_area: 800,
            },
            value: 80,
          },
          opacity: {
            value: 0.5,
          },
          shape: {
            type: "circle",
          },
          size: {
            random: true,
            value: 5,
          },
        },
        detectRetina: true,
      }}
    /> */}
      <div
        style={{ backgroundImage: `url(${herobg})`, height: "90vh" }}
        className="hero"
      >
        <div data-aos="fade-up" className="hero-content">
          <span className="text-white fs-2">HI ! I AM</span>
          <h1 className="fs-1 text-white text-uppercase pb-2">
            Ibrahim Kholilullah
          </h1>
          <h1 className="text-white">
            <Typewriter
              options={{
                strings: ["Frontend Developer", "MERN Stack Developer"],
                autoStart: true,
                loop: true,
              }}
            />
          </h1>
          <p className="text-white pb-3 fs-3">
            A Passionate web developer. Love to solve problems and work with
            cutting edge technologies
          </p>

          <a href="./Ibrahim Kholilullah - Resume.pdf" download>
            Download Resume
          </a>
        </div>
      </div>
    </div>
  );
};

export default Hero;
